import React, { useCallback, useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "../scss/components/_ag-table.scss";
import { getServerSideDatasourceInvStats } from "../helpers/serverside-datasource/inventory-stats";
import { placeholderLabels } from "@revbox/localization";
import { useCookiesContext } from "../contexts/CookiesContext";

export default function CampaignInventoryStatsTable({
    getData,
    hiddenColumns,
    colWidth,
    skin,
    currentPeriod,
    previousPeriod,
    campaignId,
    token,
    view
}) {
    const { getLanguageAbbr } = useCookiesContext();
    const language = getLanguageAbbr();
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ minHeight: "200px", width: "100%" }), []);

    const [columnDefs, setColumnDefs] = useState([]);
    const [search, setSearch] = useState('');

    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            minWidth: 90,
        };
    }, []);

    const [sortingParams, setSortingParams] = useState({
        columnName: null,
        sortOrder: null
    });

    const [gridApi, setGridApi] = useState(null);

    const onFilterTextBoxChanged = (e) => {
        setSearch(e.target.value);
    };

    const onGridReady = useCallback((params) => {
        setGridApi(params.api);
        const datasource = getServerSideDatasourceInvStats(
            getData,
            hiddenColumns,
            colWidth,
            setColumnDefs,
            search,
            currentPeriod,
            previousPeriod,
            campaignId,
            token,
            view,
            language,
            sortingParams
        );

        params.api.setGridOption("serverSideDatasource", datasource);
    }, [getData, hiddenColumns, colWidth, search, currentPeriod, previousPeriod, campaignId, token, view, language, sortingParams]);

    const onSortChanged = useCallback((event) => {
        const columnState = event.api.getColumnState();
        const sortedColumn = columnState.find(col => col.sort != null);
        
        if (sortedColumn) {
            console.log('🔄 Sort changed:', {
                colId: sortedColumn.colId,
                sort: sortedColumn.sort
            });
            setSortingParams({
                columnName: sortedColumn.colId,
                sortOrder: sortedColumn.sort
            });
        } else {
            setSortingParams({
                columnName: null,
                sortOrder: null
            });
        }
    }, []);

    useEffect(() => {
        if (gridApi) {
            const datasource = getServerSideDatasourceInvStats(
                getData,
                hiddenColumns,
                colWidth,
                setColumnDefs,
                search,
                currentPeriod,
                previousPeriod,
                campaignId,
                token,
                view,
                language,
                sortingParams
            );

            gridApi.setGridOption("serverSideDatasource", datasource);
        }
    }, [gridApi, getData, hiddenColumns, colWidth, search, currentPeriod, previousPeriod, campaignId, token, view, language, sortingParams]);


    return (
        <div style={containerStyle}>
            <div
                style={gridStyle}
                className={skin === "dark" ? "ag-theme-quartz-dark ag-theme-quartz" : "ag-theme-quartz-light ag-theme-quartz"}
            >
                <div style={{ marginBottom: "10px" }}>
                    <input
                        type="text"
                        className="input-search"
                        placeholder={placeholderLabels[language].search}
                        onInput={onFilterTextBoxChanged}
                    />
                </div>
                <AgGridReact
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    rowModelType={"serverSide"}
                    pagination={true}
                    paginationPageSize={10}
                    paginationPageSizeSelector={false}
                    cacheBlockSize={10}
                    onGridReady={onGridReady}
                    domLayout={"autoHeight"}
                    onSortChanged={onSortChanged}
                />
            </div>
        </div>
    );
};
